import { FlashModel } from './model';
import { replaceValues, uuid } from '../../lib/helpers';
import { observable, action, autorun } from 'mobx';
import { EnvModel } from '../env/model';
import { ContentModel } from '../content/model';
import { BugsnagController } from '../bugsnag/controller';
import {FlashMessageType, FlashMessageTypeInfo} from '../../types';

export class FlashController {
  constructor(
    private model: FlashModel,
    private env: EnvModel,
    private content: ContentModel,
    private bugsnag: BugsnagController
  ) {}

  @action
  createMessage = (type: FlashMessageType = FlashMessageTypeInfo, props: Object = {}, time = 8000) => {
    const identity = uuid();
    const message = observable({ identity, type, time, props, seen: false });

    this.model.messages.push(message);

    const promise = () => new Promise(resolve => {
      let timeout: any;

      if (time > 0) {
        timeout = setTimeout(() => {
          message.seen = true;
        }, time)
      }

      let dispose = autorun(() => {
        const { seen } = message;
        if (seen) {
          clearTimeout(timeout);
          if (dispose) {
            dispose();
            dispose = null;
          }

          resolve();
        }
      });
    });

    const { queue } = this.model;
    if (queue) {
      this.model.queue = queue.then(promise);
    } else {
      this.model.queue = promise();
    }
  };

  @action
  toggleSeen = (identity: string, seen: boolean = true) => {
    const message = this.model.messages.find(message => message.identity === identity);
    if (!message) return;

    message.seen = seen;
  };

  @action
  toggleAllSeen = (seen: boolean = true) => {
    this.model.messages.forEach(message => message.seen = seen);
  };

  @action
  createFromCMS = async (key: string, values: {[key: string]: string} = {}) => {
    await this.env.ready;
    const toast = this.content.toasts[key];

    if (!toast) return;

    const { title, message } = toast;

    const content = {
      title: replaceValues(title, values),
      message: replaceValues(message, values)
    };

    this.createMessage(FlashMessageTypeInfo, content);

    return true;
  }
}